const header = document.querySelector(".js-header");

if (header) {
  const hamburger = header.querySelector(".js-hamburger");
  const creamItems = header.querySelectorAll('[data-variant="cream"]');
  const orangeItems = header.querySelectorAll('[data-variant="orange"]');
  const toneTrigger = document.querySelector(".js-header-tone-trigger");
  const spQuery = window.matchMedia("(max-width: 767px)");
  const isLightTone = header.dataset.tone === "light";

  const syncState = scrolled => {
    hamburger?.toggleAttribute("data-scrolled", scrolled);

    creamItems.forEach(item => {
      item.toggleAttribute("data-active", !scrolled);
    });

    orangeItems.forEach(item => {
      item.toggleAttribute("data-active", scrolled);
    });
  };

  if (!toneTrigger) {
    syncState(spQuery.matches);
  } else {
    let ticking = false;

    const syncFromScroll = () => {
      const imagePassedHeader = toneTrigger.getBoundingClientRect().bottom <= header.getBoundingClientRect().bottom;

      // FV画像がヘッダーの下端へ達したら切り替え、スマホの下層は先頭からオレンジにする
      if (spQuery.matches) {
        syncState(isLightTone || imagePassedHeader);
      } else {
        syncState(imagePassedHeader);
      }

      ticking = false;
    };

    const requestSync = () => {
      if (ticking) return;

      ticking = true;
      requestAnimationFrame(syncFromScroll);
    };

    syncFromScroll();
    window.addEventListener("scroll", requestSync, { passive: true });
    window.addEventListener("resize", requestSync);
    spQuery.addEventListener("change", requestSync);
  }
}
